import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5d29ecd4")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" | ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", {
    class: _normalizeClass(["footer-container", { end: !$props.showLang }])
  }, [
    ($props.showLang)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: _normalizeClass(["language-button", { active: $setup.route.params.lang == 'de' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.SetLanguage('de')))
          }, " DE ", 2),
          _hoisted_2,
          _createElementVNode("button", {
            class: _normalizeClass([{ active: $setup.route.params.lang == 'en' }, "language-button"]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.SetLanguage('en')))
          }, " ENG ", 2)
        ]))
      : _createCommentVNode("", true),
    ($setup.cmsData != null)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: '/' + $setup.getLang() + '/credits'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($setup.cmsData.Title), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
  ], 2))
}